
export default {
  timelineList: [{
    year: 2021,
    img: [
      require('@/assets/images/history-bg/bg-19.png'),
    ],

    events: [
      '与华为云达成合作，成为华为云鲲鹏凌云伙伴',
      '获得"珠海市最佳软件技术创新产品奖"'
    ]
  }, {
    year: 2020,
    style:"margin-top:-80px",
    img: [
      require('@/assets/images/history-bg/bg-18.png'),
    ],
    events: [
      '通过CMMI L5 认证',
      '通过IS09001:2015认证',
      '获得“技术先进型服务企业”称号'
    ]
  }, {

    year: 2019,
    style:"margin-top:-100px",
    img: [require('@/assets/images/history-bg/bg-17.png')],
    events: [
      'APJ清华科技园新办公区启用',
      'HSL ODC成立',
      'ESQUEL软件解决方案中心成立',

      'HK ELECTRIC ODC成立'
    ]
  }, {
    year: 2018,
    img: [require('@/assets/images/history-bg/bg-16.png')],
    events: [
      '通过ISO27001认证',
      'OCTOPUS ODC成立'
    ]
  }, {
    year: 2017,
    img: [require('@/assets/images/history-bg/bg-15-1.png'), require('@/assets/images/history-bg/bg-15-2.png')],
    events: [
      '两项产品通过广东省高新技术产品认证',
      '获得“珠海市服务外包优秀企业”称号',
      '被推选为珠海市软件行业协会副会长单位'
    ]
  }, {
    year: 2016,
    img: [require('@/assets/images/history-bg/bg-14.png')],
    events: [
      '荣获国家高新技术企业认证',
      '获得“广东省现代服务业示范企业”称号'
    ]
  }, {
    year: 2015,
    img: [require('@/assets/images/history-bg/bg-13.png')],
    events: [
      'APJ南方软件园办公区启用',
      '获得“广东最佳政府及公共服务外包企业”称号'
    ]
  }, {
    year: 2014,
    img: [require('@/assets/images/history-bg/bg-12.png')],
    events: [
      'ESQUEL DC 成立'
    ]
  }, {
    year: 2013,
    img: [require('@/assets/images/history-bg/bg-11.png')],
    events: [
      '获得“2011年-2012年度广东省重点软件出口企业”称号',
      '获得“广东省服务外包重点培育企业”称号'
    ]
  }, {
    year: 2012,
    img: [require('@/assets/images/history-bg/bg-10.png')],
    events: [
      '发起成立珠海市服务外包行业协会并任首任会长单位'
    ]
  }, {
    year: 2011,
    img: [require('@/assets/images/history-bg/bg-9.png')],
    events: [
      '通过CMMI L3 认证'
    ]
  }, {
    year: 2010,
    img: [require('@/assets/images/history-bg/bg-8.png')],
    events: [
      '获得港铁杰出贡献奖'
    ]
  }, {
      year: 2009,
      img: [require('@/assets/images/history-bg/bg-7.png')],
      events: [
        '获得香港资讯科技奖最佳合作奖',
      ]
    }, {
    year: 2008,
    img: [require('@/assets/images/history-bg/bg-6.png')],
    events: [
      'Bossini ODC 成立',
      '荣获软件企业“双软认证”'
    ]
  }, {
    year: 2007,
    img: [require('@/assets/images/history-bg/bg-5.png')],
    events: [
      'Towngas ODC 成立'
    ]
  }, {
    //   year: 2006,
    //   events: [
    //   ]
    // }, {
    year: 2005,
    img: [require('@/assets/images/history-bg/bg-4.png')],
    events: [
      '通过CMMI L2 认证'
    ]
  }, {
    year: 2004,
    img: [require('@/assets/images/history-bg/bg-3.png')], // ?????
    events: [
      '通过ISO 9001: 2000认证'
    ]
  }, {
    year: 2003,
    img: [require('@/assets/images/history-bg/bg-2.png')], // ?????
    events: [
      'MTR ODC 成立',

    ]
  }, {
    year: 2002,
    img: [require('@/assets/images/history-bg/bg-1.png')],
    events: [
      'APJ成立'
    ]
  }
  ]
}



// WEBPACK FOOTER //
// ./src/views/aboutus/history/apj-timeline.js